import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Force clear any existing service workers to prevent conflicts
serviceWorker.forceClearServiceWorkers().then(() => {
  // Register service worker for PWA functionality
  serviceWorker.register({
    onSuccess: (registration) => {
      console.log('PWA: Service Worker registered successfully');
      
      // Check if app can be installed
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        console.log('PWA: Push notifications supported');
      }
    },
    onUpdate: (registration) => {
      console.log('PWA: New version available');
      
      // Only show update prompt once per session to prevent loops
      const updatePromptShown = sessionStorage.getItem('updatePromptShown');
      if (!updatePromptShown) {
        sessionStorage.setItem('updatePromptShown', 'true');
        
        // Notify user about update using a custom confirmation
        let shouldUpdate = true; // Default to true
        
        // Check if confirm is available and use it safely
        if (typeof window !== 'undefined' && window.confirm) {
          try {
            shouldUpdate = window.confirm('A new version is available! Would you like to update?');
          } catch (error) {
            console.warn('Confirm dialog failed:', error);
            shouldUpdate = true; // Default to update on error
          }
        }
        
        if (shouldUpdate) {
          window.location.reload();
        }
      }
    }
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);